import styles from './Leaderboard.module.css';
import { useState } from 'react';
import type { LeaderboardData } from '../types/leaderboard.ts';

interface TournamentLeaderboardProps {
  data: LeaderboardData;
}

const Leaderboard = ({ data }: TournamentLeaderboardProps) => {
  const [activeTab, setActiveTab] = useState<'current' | 'lifetime'>('current');

  const currentUserData =
    activeTab === 'current' ? data.current_me : data.lifetime_me;
  const leaderboardEntries =
    activeTab === 'current' ? data.current_month : data.lifetime;

  const getTrophy = (placement: number) => {
    const placementStore: { [key: number]: string } = {
      1: styles.first,
      2: styles.second,
      3: styles.third,
    };
    return placementStore[placement] ?? styles.default;
  };

  return (
    <div className={styles.container}>
      <div className={styles.tabs}>
        <button
          className={`${styles.tab} ${
            activeTab === 'current' ? styles.tabActive : styles.tabInactive
          }`}
          onClick={() => setActiveTab('current')}
        >
          Этот месяц
        </button>
        <button
          className={`${styles.tab} ${
            activeTab === 'lifetime' ? styles.tabActive : styles.tabInactive
          }`}
          onClick={() => setActiveTab('lifetime')}
        >
          За все время
        </button>
      </div>
      <div className={styles.leaderboard}>
        <div className={styles.leaderboardItem}>
          <div className={styles.avatarAndRank}>
            <div className={styles.avatar}>
              <img src={currentUserData.user.photo_url} alt="Profile picture" />
            </div>
            <div className={`${styles.rank} ${getTrophy(currentUserData.placement)}`}>
              <p>{currentUserData.placement}</p>
            </div>
          </div>
          <div className={styles.userName}>
            <p className={styles.userNameTextSelf}>
              {currentUserData.user.username} <span>(Вы)</span>
            </p>
          </div>
          <div className={styles.coins}>
            <div className={styles.coinIconSmall}></div>
            <span className={styles.coinValueSelf}>
              {currentUserData.earned.amount.toLocaleString()}
            </span>
          </div>
        </div>
        <div className={styles.entriesContainer}>
          {leaderboardEntries.map((entry) => (
            <div key={entry.user.id} className={styles.listEntry}>
              <div className={styles.avatarAndRank}>
                <div className={styles.avatar}>
                  <img src={entry.user.photo_url} alt="Profile picture" />
                </div>
                <div className={`${styles.rank} ${getTrophy(entry.placement)}`}>
                  <p>{entry.placement}</p>
                </div>
              </div>
              <div className={styles.userName}>
                <p className={styles.userNameText}>{entry.user.username}</p>
              </div>
              <div className={styles.coins}>
                <div className={styles.coinIconSmall}></div>
                <span className={styles.coinValue}>
                  {entry.earned.amount.toLocaleString()}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Leaderboard;
